/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Irrigation_Settings_CardInputs */

const vi_smartlab_irrigation_settings_card = /** @type {(inputs: Smartlab_Irrigation_Settings_CardInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phun nước`)
};

/**

* @param {Smartlab_Irrigation_Settings_CardInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_irrigation_settings_card = /** @type {((inputs?: Smartlab_Irrigation_Settings_CardInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Irrigation_Settings_CardInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_irrigation_settings_card(inputs)
});